<template>
  <div class="h-full overflow-hidden">
    <div class="sample-list">
      <div class="sample-item" :style="`background-image: url(${item.bgImg});`" v-for="item in sampleList" :key="item.name">
        <div class="sample-name">{{ item.name }}</div>
        <div class="sample-value">{{ item.value }}</div>
      </div>
    </div>

    <categoryTitle class="mt-10px mb-10px" title="最新样品" />

    <el-table
      ref="scrollTable"
      :data="tableData"
      :height="`calc(100% - 310px)`"
      v-loading="tableLoading"
      highlight-current-row
      @mouseenter.native="mouseBtn('moveIn')"
      @mouseleave.native="mouseBtn('remove')"
    >
      <el-table-column prop="type" label="类型" width="60px" align="center"></el-table-column>
      <el-table-column prop="name" label="样品名称" width="190px" align="center"></el-table-column>
      <el-table-column prop="date" label="日期" width="97px" align="center"></el-table-column>
    </el-table>

    <div class="mt-12px h-200px">
      <lineChart />
    </div>
    <certList />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { CombustionLaboratoryApi } from '@wiz-api/huizhou2-business'
import lineChart from './lineChart'
import certList from './certList'

const combustionLaboratoryApi = new CombustionLaboratoryApi()

export default {
  name: 'sampleInformation',
  components: {
    categoryTitle,
    lineChart,
    certList
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sampleList: [
        { name: '入库待检', value: 0, bgImg: require('./image/back-01.png') },
        { name: '已领待取', value: 0, bgImg: require('./image/back-02.png') },
        { name: '已出库', value: 0, bgImg: require('./image/back-03.png') },
        { name: '检定报告', value: 0, bgImg: require('./image/back-04.png') },
      ],
      tableLoading: false,
      tableData: [],
      scrollDirection: 'down', // 滚动方向 up向上 down向下
      scrollTimer: null,
      reportImg: require('./image/cert/report.png'),
    }
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  methods: {
    // 获取统计数据
    async getSpecimenCount() {
      const [err, res] = await combustionLaboratoryApi.getSpecimenCount()
      if (!err && res) {
        this.sampleList[0].value = res?.inboundForInspectionCount || 10
        this.sampleList[1].value = res?.inspectedForPickupCount || 20
        this.sampleList[2].value = res?.dispatchedCount || 30
        this.sampleList[3].value = res?.verificationReportCount || 40
      }
    },
    // 获取最新样本列表
    async getSpecimenList() {
      this.tableLoading = true
      const [err, res] = await combustionLaboratoryApi.getLatestSpecimens()
      this.tableLoading = false
      if (!err && res) {
        this.tableData = res.map((item) => {
          return {
            ...item,
            date: item._date ? dayjs(item._date).format('YYYY-MM-DD') : '-'
          }
        })
        console.log('tableData===', this.tableData)
      }
    },
    autoScroll() {
      const dom = this.$refs.scrollTable?.$refs?.bodyWrapper
      if (dom) {
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        if (scrollHeight - clientHeight <= 0) return
        this.scrollFun()
      }
    },
    scrollFun() {
      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        const dom = this.$refs.scrollTable?.$refs?.bodyWrapper
        if (!dom) {
          clearInterval(this.scrollTimer)
          return
        }
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        const scrollTop = dom.scrollTop
        // 向下滚动
        if (this.scrollDirection === 'down') {
          dom.scrollTop = scrollTop + 1
          if (scrollHeight - clientHeight <= scrollTop + 1) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'up'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
          // 向上滚动
        } else if (this.scrollDirection === 'up') {
          dom.scrollTop = scrollTop - 1
          if (scrollTop - 1 <= 0) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'down'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
        }
      }, 150)
    },
    mouseBtn(type) {
      if (type === 'moveIn') {
        this.stopScroll()
      } else if (type === 'remove') {
        this.autoScroll()
      }
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    // 表格行点击事件-暂时不用
    async rowClick(row) {
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(this.getKksCode(row.code))
      if (codeInfo && codeInfo.item) {
        this.player.Native.Camera.moveToItem(codeInfo.item, 1)
        await this.setRootModelShow(false)
        await this.setDisabledPanel(false, [row.code])
        this.player.Native.ModelTree.setItemVisible([codeInfo.item], true)
      } else {
        await this.setRootModelShow(true)
        await this.setDisabledPanel(true)
      }
    },
    // 设置不展示面板
    async setDisabledPanel(showAll, codeList) {
      const openEvent = new CustomEvent('setDisabledPanel', {
        detail: {
          codeList: codeList || [],
          showAll,
        },
      })
      window.dispatchEvent(openEvent)
    },
    async setRootModelShow(show) {
      let root = await this.player.Native.ModelTree.getRootItems()
      root = root.filter((item) => { return item.itemType !== 2 })
      const rootList = root.map((val) => {
        return val.item
      })
      this.player.Native.ModelTree.setItemVisible(rootList, show)
    },
    openDetail() {
      this.$emit('transferEvent', {
        toCom: { code: 'TheNewCheckTask', origin: 'SampleInformation', name: '最新验定任务' },
        type: 'mainComponent',
        props: {},
      })
    }
  },
  mounted() {
    this.getSpecimenCount()
    this.getSpecimenList()
    setTimeout(() => {
      this.autoScroll()
    }, 1000)
  },
  created() {
    this.openDetail()
  },
  async beforeDestroy() {
    await this.setRootModelShow(true)
    await this.setDisabledPanel(true)
    this.stopScroll()
  },
}
</script>

<style lang="scss" scoped>
.sample-list {
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
  color: #fff;
  .sample-item {
    margin-right: 8px;
    width: 150px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    text-align: center;
    &:last-child {
      margin-right: 0;
    }
    .sample-name {
      margin-top: 4px;
      font-size: 14px;
      color: #fffc;
    }
    .sample-value {
      font-size: 18px;
      font-weight: bold;
    }
  }
}

::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      padding-left: 2px;
      padding-right: 0;
      line-height: 14px;
    }
    th.el-table__cell>.cell {
      padding-left: 2px;
      padding-right: 0;
    }
  }
}
</style>
